<template>
  <header class="site-header">
    <div class="header-logo">
      <router-link to="/index" class="logo-img"><img src="../assets/logo-sm.png" :alt="$t('unicapsule')" /></router-link>
      <router-link to="/index" class="logo-text">{{
        $t("unicapsule")
        }}</router-link>
    </div>
    <div class="header-navbar navbar" v-if="!inEditor">
      <router-link to="/event" class="pointer">
        {{$t('event')}}
      </router-link>
      <span class="muted"">|</span>
        <router-link v-if=" !authInfo" to="/login">{{ $t("signin") }}</router-link>
        <router-link v-if="!authInfo" to="/reg">{{ $t("signup") }}</router-link>
        <!-- <notice v-if="authInfo"></notice> -->
        <ui-avatar @click.native.stop.prevent="popoverAvatar" ref="avatar" class="pointer" v-if="authInfo" size="sm" :url="authInfo.avatar" :username="authInfo.username">
          <!-- <ui-icon name="icon-user"></ui-icon> -->
        </ui-avatar>
        <span class="muted" v-if="authInfo">|</span>
        <span v-if="authInfo" class="pointer" @click.stop.prevent="popoverManage" id="popover-manage">
          <ui-icon name="read"></ui-icon>{{ $t("management") }}
        </span>
        <span class="muted" v-if="authInfo && authInfo.role == 'admin'">|</span>
        <router-link v-if="authInfo && authInfo.role == 'admin'" to="/admin">unicapsule-admin</router-link>
        <span class="muted" v-if="authInfo && authInfo.role == 'admin'">|</span>
        <router-link v-if="authInfo" to="/create" class="create-button">
          <ui-icon name="icon-plus"></ui-icon>
          <span class="hide-on-sm">{{ $t("newBook") }}</span>
        </router-link>
    </div>
    <div class="header-navbar navbar" v-if="inEditor">
      <!-- <ui-button type="border" @click.stop.native="doPublishArticle('draft')">{{$t('saveAsDraft')}}</ui-button> -->
      <ui-button type="primary" @click.stop.native="doPublishArticle('publish')">{{ $t("saveArticle") }}</ui-button>
    </div>
  </header>
</template>
<script>
import { mapGetters } from "vuex";
import { convertUrl } from "../utils/utils.js";
// import Notice from "./Notice.vue";
import event from "../utils/event.js";
import addEventForChild from "../utils/addEventForChild.js";
export default {
  data() {
    return {};
  },
  methods: {
    logout: function() {
      this.$store.dispatch("doLogout");
      if (this.$route.meta.auth) {
        this.$router.push("");
      }
    },
    doPublishArticle(type) {
      event.$emit("add-article", type);
    },
    goSetting() {
      this.$router.push("/profile");
    },
    popoverManage() {
      this.$UiDropdown({
        reference: this.$el.querySelector("#popover-manage"),
        list: [{
            icon: "book",
            title: this.$t("createdBook"),
            onClick: () => this.$router.push("/home/createdBook")
          },
          {
            icon: "file-copy",
            title: this.$t("joinedBook"),
            onClick: () => this.$router.push("/home/joinedBook")
          },
          {
            icon: "heart",
            title: this.$t("favedBook"),
            onClick: () => this.$router.push("/home/favedBook")
          },
          {
            icon: "snippets",
            title: this.$t("createdArticle"),
            onClick: () => this.$router.push("/home/createdArticle")
          },
          {
            icon: "mail",
            title: this.$t("favedArticle"),
            onClick: () => this.$router.push("/home/favedArticle")
          }
        ]
      });
    },
    popoverAvatar() {
      this.$UiDropdown({
        reference: this.$el.querySelector(".ui-avatar"),
        list: [{
            icon: "setting",
            title: this.$t("updateProfile"),
            onClick: this.goSetting
          },
          { icon: "export", title: this.$t("signOut"), onClick: this.logout }
        ]
      });
    }
  },
  computed: {
    ...mapGetters(["authInfo"]),
    inEditor() {
      return (
        this.$route.meta.inEditor
      );
    }
  },
  mounted() {},
  components: {
    // Notsice
  }
};

</script>
